import React, { useContext, useEffect, useState } from "react";
import { Title } from "../../../../../stories/Title/Title";
import Close from "../../../../../images/Close.svg";
import { TextField } from "@mui/material";
import { Operation, PageFor, empType } from "../../../../../utils/Enum.types";
import { Button } from "../../../../../stories/Button/Button";
import { Label } from "../../../../../stories/Label/Label";
import PhoneInput from "react-phone-input-2";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import {
  DEFAULT_TIME,
  EMPTY_STRING,
  emptyMessage,
  imageFormats,
  ROWS_PER_PAGE,
} from "../../../../../utils/constants";

import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import { Form, Formik, FormikProps } from "formik";
import { useLazyQuery, useMutation } from "@apollo/client";
import { GetSupplierByNodeId } from "../supplier/queries/queries";
import { nodeVar, OrderDirection } from "../../../../../utils/commonQueryTypes";
import { LabelProps } from "../../../../../utils/types";
import InputNumber from "../../../../common/Input/InputNumber";
import {
  PredefinedDataTypes,
  ProjectRequiredDetails,
} from "../../../../../utils/formTypes";
import TextArea from "../../../../../stories/TextArea/TextArea";
import { Keys } from "../../../../../utils/Enum.keys";
import {
  handleMUISelectEvent,
  toInputStandardDate,
  toIsoDate,
} from "../../../../../utils/UtilFunctions";
import InputHoc from "../../../../common/Input/Index";
import { projectDetailsValidation } from "../../../../../utils/validationSchema";
import MessageModal from "../../../../../customComponents/MessageModal";
import { AppContext } from "../../../../../context/context";
import LoadingModal from "../../../../pages/LoadingModal";
import PredefinedSelect from "../../../../../customComponents/PredefinedSelect";
import useLabels from "../../../../../customHooks/useLabels";
import useFormJson from "../../../../../json/useFormJson";
import {
  AddProjectResult,
  AddProjectVar,
  AtsAcLdgrProjects,
  AtsAcLdgrProjectsOrderField,
  UpdateProjectResult,
  UpdateProjectVar,
} from "./queries/types";
import { AddProject, UpdateProject } from "./queries/mutations";
import { payloadTypes } from "../../../../../context/reducer";
import DataFetch from "../../../../../images/OpenIcon.svg";
import SuppliersAutocomplete from "../../purchase/purchaseorder/rfqtopo/components/SuppliersAutocomplete";
import { AtsAcLdgr, LdgrQueryType } from "../supplier/queries/types";
import { GetProjectByNodeId, GetProjects } from "./queries/queries";
import Supplier from "../supplier/Index";
import { AddModalStyles } from "../../../../../styles/CustomModalStyles";
import Modal from "react-modal";
import FileAttach from "../../../../../images/BrowseFiles.svg";
import Upload from "../../../../../images/Upload.svg";
import Input from "../../../../../stories/Input/Input";
import { getDownloadUrl } from "../../../../../utils/DownloadFile";
import DownloadImage from "../../../../../images/DownloadImage.svg";
import DownloadPdf from "../../../../../images/DownloadPdf.svg";
import { handleUploadAndDownloadFile } from "../../../../../utils/Upload";
import Eye from "../../../../../images/Eye.svg";
import AddProjectExtDetails from "../projectExt/AddProjectExtDetails";
import ProjectExtDetails from "../projectExt";

export interface supplierProps {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
  operation: Operation;
}

const AddProjectDetails = ({ operation, setModalFlag }: supplierProps) => {
  const { ledgerLabel } = useLabels();
  const { ProjectDetails } = useFormJson();
  const { customer_id, company_id } = useUrlParams();
  const [message, setMessage] = useState(emptyMessage);

  const { user_details } = useLoggedInUserDetails();
  const { state, dispatch } = useContext(AppContext);

  const [progress, setProgress] = useState(0);

  const [agreementFile, setAgreementFile] = useState<File | null>(null);
  const [endAgreementFile, setEndAgreementFile] = useState<File | null>(null);
  const [supplierModal, setSupplierModal] = useState(false);
  const [projectExtModalFlag, setProjectExtModalFlag] = useState(false);
  const [projectExtViewModalFlag, setProjectExtViewModalFlag] = useState(false);

  const initialEmpDetails = {
    supplierId: 0,
    supplierName: "",
    email: "",
    phone: "",
    state: "",
    gstNo: "",
    proficiency: "",
  };
  const [empDetails, setEmpDetails] = useState(initialEmpDetails);

  const initialValues: ProjectRequiredDetails = {
    name: "",
    workOrderNum: "",
    contractValue: 0,
    projectScope: "",
    contractSignedWith: "",
    loa: "",
    agreementDate: "",
    startDate: "",
    endDate: "",
    insuranceStartDate: "",
    insuranceEndDate: "",
    goLiveDate: "",
    amcStartDate: "",
    amcScope: "",
    amcInsuranceStartDate: "",
    amcInsuranceEndDate: "",
    dlpStartDate: "",
    dlpEndDate: "",
    bgValue: 0,
    bgStartDate: "",
    bgEndDate: "",
    slaBillingCycle: "",
    agreementFile: "",
    endAgreementFile: "",
  };

  const [formData, setFormData] =
    useState<ProjectRequiredDetails>(initialValues);

  const [addProject, { loading: AddProjectLoading }] = useMutation<
    AddProjectResult,
    AddProjectVar
  >(AddProject, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const [updateProject, { loading: updateLoading }] = useMutation<
    UpdateProjectResult,
    UpdateProjectVar
  >(UpdateProject, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const [GetSupplier, { data: supplierData }] = useLazyQuery<
    { node: AtsAcLdgr },
    nodeVar
  >(GetSupplierByNodeId);

  const [getProjectByNodeId, { data: projectData, loading }] = useLazyQuery<
    { node: AtsAcLdgrProjects },
    nodeVar
  >(GetProjectByNodeId);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (state.supplierId && operation === Operation.CREATE) {
          GetSupplier({
            variables: {
              id: state.supplierId,
            },
          }).then(({ data }) => {
            if (data && data.node)
              setEmpDetails({
                supplierId: data.node.id,
                supplierName: data.node.desc,
                state: data.node.supplier_details.state,
                phone: data.node.supplier_details.phone,
                email: data.node.supplier_details.email,
                gstNo: data.node.supplier_details.gstNo,
                proficiency: data.node.supplier_details.proficiency,
              });
          });
        }
      } catch (err) {
        console.error((err as Error).message);
      }
    };
    fetchData();
  }, [GetSupplier, state.supplierId]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (state.projectId && operation !== Operation.CREATE) {
          getProjectByNodeId({
            variables: {
              id: state.projectId,
            },
          }).then(({ data }) => {
            if (data && data.node) {
              setFormData({
                name: data.node.name,
                workOrderNum: data.node.workOrderNum,
                contractValue: data.node.contractValue,
                projectScope: data.node.projectScope,
                contractSignedWith: data.node.contractSignedWith,
                loa: toInputStandardDate(data.node.loa),
                agreementDate: toInputStandardDate(data.node.agreementDate),
                startDate: toInputStandardDate(data.node.startDate),
                endDate: toInputStandardDate(data.node.endDate),
                insuranceStartDate: toInputStandardDate(
                  data.node.insuranceStartDate
                ),
                insuranceEndDate: toInputStandardDate(
                  data.node.insuranceEndDate
                ),
                goLiveDate: toInputStandardDate(data.node.goLiveDate),
                amcStartDate: toInputStandardDate(data.node.amcStartDate),
                amcScope: data.node.amcScope,
                amcInsuranceStartDate: toInputStandardDate(
                  data.node.amcInsuranceStartDate
                ),
                amcInsuranceEndDate: toInputStandardDate(
                  data.node.amcInsuranceEndDate
                ),
                dlpStartDate: toInputStandardDate(data.node.dlpStartDate),
                dlpEndDate: toInputStandardDate(data.node.dlpEndDate),
                bgValue: data.node.bgValue,
                bgStartDate: toInputStandardDate(data.node.bgStartDate),
                bgEndDate: toInputStandardDate(data.node.bgEndDate),
                slaBillingCycle: data.node.slaBillingCycle,
                agreementFile: data.node.agreementFile,
                endAgreementFile: data.node.endAgreementFile,
              });
              setEmpDetails({
                supplierId: data.node.supplierName.id,
                supplierName: data.node.supplierName.desc,
                state: data.node.supplierName.supplier_details.state,
                phone: data.node.supplierName.supplier_details.phone,
                email: data.node.supplierName.supplier_details.email,
                gstNo: data.node.supplierName.supplier_details.gstNo,
                proficiency:
                  data.node.supplierName.supplier_details.proficiency,
              });
              dispatch({
                type: payloadTypes.SET_SUPPLIER_ID,
                payload: {
                  supplierId: data.node.supplierName.id as number,
                },
              });
            }
          });
        }
      } catch (err) {
        console.error((err as Error).message);
      }
    };
    fetchData();
  }, [getProjectByNodeId, state.projectId]);

  const handleValueChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    meta: FormikProps<ProjectRequiredDetails>
  ) => {
    const { name, value } = e.target as HTMLInputElement;

    setFormData(() => ({
      ...formData,
      [name]: value,
    }));
    meta.handleChange(e);
  };
  const handleNumberChange = (name: string, value: string) => {
    setFormData((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    if (customer_id) {
      let input = {
        name: formData.name,
        workOrderNum: formData.workOrderNum,
        contractValue: formData.contractValue,
        projectScope: formData.projectScope,
        contractSignedWith: formData.contractSignedWith,
        loa: toIsoDate(formData.loa ? formData.loa : DEFAULT_TIME),
        agreementDate: toIsoDate(
          formData.agreementDate ? formData.agreementDate : DEFAULT_TIME
        ),
        startDate: toIsoDate(
          formData.startDate ? formData.startDate : DEFAULT_TIME
        ),
        endDate: toIsoDate(formData.endDate ? formData.endDate : DEFAULT_TIME),
        insuranceStartDate: toIsoDate(
          formData.insuranceStartDate
            ? formData.insuranceStartDate
            : DEFAULT_TIME
        ),
        insuranceEndDate: toIsoDate(
          formData.insuranceEndDate ? formData.insuranceEndDate : DEFAULT_TIME
        ),
        goLiveDate: toIsoDate(
          formData.goLiveDate ? formData.goLiveDate : DEFAULT_TIME
        ),
        amcStartDate: toIsoDate(
          formData.amcStartDate ? formData.amcStartDate : DEFAULT_TIME
        ),
        amcScope: formData.amcScope,
        amcInsuranceStartDate: toIsoDate(
          formData.amcInsuranceStartDate
            ? formData.amcInsuranceStartDate
            : DEFAULT_TIME
        ),
        amcInsuranceEndDate: toIsoDate(
          formData.amcInsuranceEndDate
            ? formData.amcInsuranceEndDate
            : DEFAULT_TIME
        ),
        dlpStartDate: toIsoDate(
          formData.dlpStartDate ? formData.dlpStartDate : DEFAULT_TIME
        ),
        dlpEndDate: toIsoDate(
          formData.dlpEndDate ? formData.dlpEndDate : DEFAULT_TIME
        ),
        bgValue: formData.bgValue,
        bgStartDate: toIsoDate(
          formData.bgStartDate ? formData.bgStartDate : DEFAULT_TIME
        ),
        bgEndDate: toIsoDate(
          formData.bgEndDate ? formData.bgEndDate : DEFAULT_TIME
        ),
        slaBillingCycle: formData.slaBillingCycle,
        agreementFile: formData.agreementFile,
        endAgreementFile: formData.endAgreementFile,
      };

      if (operation === Operation.CREATE && state.supplierId) {
        addProject({
          variables: {
            user_details,
            ldgrID: state.supplierId ? state.supplierId : 0,
            customerID: customer_id,
            input,
          },
          refetchQueries: [
            {
              query: GetProjects,
              variables: {
                customerID: customer_id,
                empID: user_details.id,
                after: null,
                first: ROWS_PER_PAGE,
                name: EMPTY_STRING,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsAcLdgrProjectsOrderField.CREATED_AT,
                },
              },
            },
          ],
        }).then(({ data }) => {
          if (data && data.AddProject) {
            setMessage({
              flag: true,
              message: `${ledgerLabel} Project details added successfully`,
              operation: Operation.CREATE,
            });
            const uploadFilePromise = agreementFile
              ? handleUploadAndDownloadFile(
                  agreementFile,
                  `${customer_id}/vendor/${state.supplierId}/projects/${
                    data.AddProject.id
                  }/agreementFile.${
                    agreementFile.name.split(".")[
                      agreementFile.name.split(".").length - 1
                    ]
                  }`,
                  setProgress,
                  false
                )
              : false;
            const uploadEndAgreementFilePromise = endAgreementFile
              ? handleUploadAndDownloadFile(
                  endAgreementFile,
                  `${customer_id}/vendor/${state.supplierId}/projects/${
                    data.AddProject.id
                  }/endAgreementFile.${
                    endAgreementFile.name.split(".")[
                      endAgreementFile.name.split(".").length - 1
                    ]
                  }`,
                  setProgress,
                  false
                )
              : false;
            if (uploadFilePromise || uploadEndAgreementFilePromise) {
              Promise.all([
                uploadFilePromise,
                uploadEndAgreementFilePromise,
              ]).then(([sendMsgData]) => {
                if (sendMsgData) {
                  setAgreementFile(null);
                  setEndAgreementFile(null);
                }
              });
            }
          }
        });
      } else {
        updateProject({
          variables: {
            user_details,
            customerID: customer_id,
            projectID: state.projectId,
            input: {
              ...input,
              ldgrID: state.supplierId ? state.supplierId : 0,
            },
          },
          refetchQueries: [
            {
              query: GetProjects,
              variables: {
                customerID: customer_id,
                empID: user_details.id,
                after: null,
                first: ROWS_PER_PAGE,
                name: EMPTY_STRING,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsAcLdgrProjectsOrderField.CREATED_AT,
                },
              },
            },
          ],
        }).then(({ data }) => {
          if (data && data.UpdateProject) {
            setMessage({
              flag: true,
              message: `${ledgerLabel} Project details updated successfully`,
              operation: Operation.CREATE,
            });
            const uploadFilePromise = agreementFile
              ? handleUploadAndDownloadFile(
                  agreementFile,
                  `${customer_id}/vendor/${state.supplierId}/projects/${
                    data.UpdateProject.id
                  }/agreementFile.${
                    agreementFile.name.split(".")[
                      agreementFile.name.split(".").length - 1
                    ]
                  }`,
                  setProgress,
                  false
                )
              : false;
            const uploadEndAgreementFilePromise = endAgreementFile
              ? handleUploadAndDownloadFile(
                  endAgreementFile,
                  `${customer_id}/vendor/${state.supplierId}/projects/${
                    data.UpdateProject.id
                  }/endAgreementFile.${
                    endAgreementFile.name.split(".")[
                      endAgreementFile.name.split(".").length - 1
                    ]
                  }`,
                  setProgress,
                  false
                )
              : false;
            if (uploadFilePromise || uploadEndAgreementFilePromise) {
              Promise.all([
                uploadFilePromise,
                uploadEndAgreementFilePromise,
              ]).then(([sendMsgData]) => {
                if (sendMsgData) {
                  setAgreementFile(null);
                  setEndAgreementFile(null);
                }
              });
            }
          }
        });
      }
    } else {
      if (customer_id) {
        setMessage({
          flag: true,
          message: "Customer details not found",
          operation: Operation.NONE,
        });
      } else
        setMessage({
          flag: true,
          message: `${ledgerLabel} details not found`,
          operation: Operation.NONE,
        });
    }
  };

  const handleClear = () => {
    const inputElement = document.getElementsByName(
      "name"
    )[0] as HTMLInputElement;
    if (inputElement) inputElement.focus();
    setFormData(initialValues);
  };

  const handleClose = () => {
    if (message.operation !== Operation.NONE) {
      handleClear();
      setModalFlag(false);
      dispatch({
        type: payloadTypes.SET_SUPPLIER_ID,
        payload: {
          supplierId: 0,
        },
      });
    }
    setMessage(emptyMessage);
  };

  return (
    <>
      <div className="projects-add">
        <div className="projects-add__title">
          <Title>
            {operation === Operation.UPDATE ? "Edit" : "Add "} Project Details
          </Title>

          <img
            src={Close}
            alt=""
            onClick={() => setModalFlag(false)}
            className="modal-close-icon"
          />
        </div>
        <div className="projects-add__filters row g-0">
          <div className="col-4">
            {operation !== Operation.VIEW ? (
              <div className="projects-add__filters--flex">
                <SuppliersAutocomplete
                  onChange={(newValue) => {
                    if (newValue) {
                      dispatch({
                        type: payloadTypes.SET_SUPPLIER_ID,
                        payload: {
                          supplierId: newValue.value as number,
                        },
                      });
                    } else {
                      dispatch({
                        type: payloadTypes.SET_SUPPLIER_ID,
                        payload: {
                          supplierId: 0,
                        },
                      });
                    }
                  }}
                  onKeyDown={() => {}}
                  value={state.supplierId ? state.supplierId : 0}
                  label={ledgerLabel}
                  input={{
                    itemID: 0,
                    query_type: LdgrQueryType.ALL,
                    tableLevel: undefined,
                  }}
                />
                <img
                  src={DataFetch}
                  alt=""
                  onClick={() => setSupplierModal(!supplierModal)}
                  className="data-fetch-icon"
                />
              </div>
            ) : (
              <TextField
                label="Name"
                slotProps={{
                  inputLabel: {
                    shrink: true,
                  },
                }}
                disabled
                value={empDetails.supplierName}
                className="assign-user-rights__textfield"
              />
            )}

            <TextField
              label="Mobile"
              slotProps={{
                inputLabel: {
                  shrink: true,
                },
              }}
              disabled
              value={empDetails.phone}
              className="assign-user-rights__textfield"
            />
          </div>
          <div className="col-4">
            <div>
              <TextField
                label="GST No"
                slotProps={{
                  inputLabel: {
                    shrink: true,
                  },
                }}
                disabled
                value={empDetails.gstNo}
                className="assign-user-rights__textfield"
              />
              <TextField
                label="Email"
                slotProps={{
                  inputLabel: {
                    shrink: true,
                  },
                }}
                value={empDetails.email}
                className="assign-user-rights__textfield"
                disabled
              />
            </div>
          </div>
          <div className="col">
            <TextField
              label="State"
              slotProps={{
                inputLabel: {
                  shrink: true,
                },
              }}
              value={empDetails.state}
              className="assign-user-rights__textfield"
              disabled
            />
            <TextField
              label="Proficiency"
              slotProps={{
                inputLabel: {
                  shrink: true,
                },
              }}
              value={empDetails.proficiency}
              className="assign-user-rights__textfield"
              disabled
            />
          </div>
        </div>
        <Formik
          initialValues={formData}
          validationSchema={projectDetailsValidation}
          onSubmit={handleSubmit}
          enableReinitialize
          validateOnChange
        >
          {(meta) => {
            return (
              <Form className="projects-add__form">
                <div className="projects-add__form--details row g-0">
                  <div className=" col">
                    <div className="projects-add__form--details--h">
                      <h4>Project Details</h4>
                    </div>
                    {ProjectDetails.left.map(
                      (field: LabelProps, key: React.Key) => {
                        if (field.dataType === "number") {
                          return (
                            <React.Fragment>
                              <div className="label-grid">
                                <Label>{field.labelName}</Label>
                                <InputNumber
                                  value={formData[field.inputName]}
                                  name={field.inputName}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLInputElement>
                                  ) => handleValueChange(e, meta)}
                                  required={field.required}
                                  maxLength={field.maxLength}
                                  disabled={
                                    operation === Operation.VIEW ? true : false
                                  }
                                />
                              </div>
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        } else if (field.dataType === "textarea") {
                          return (
                            <React.Fragment>
                              <div className="label-grid" key={key}>
                                <Label>{field.labelName}</Label>
                                <TextArea
                                  value={formData[field.inputName]}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLTextAreaElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  type={field.dataType}
                                  rows={3}
                                  name={field.inputName}
                                  disabled={
                                    operation === Operation.VIEW ? true : false
                                  }
                                />
                              </div>
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        } else if (field.dataType === "mobile") {
                          return (
                            <div className="label-grid">
                              <Label>{field.labelName}</Label>
                              <PhoneInput
                                country={"in"}
                                value={formData[field.inputName] as string}
                                onChange={(e: string) => {
                                  handleNumberChange(field.inputName, e);
                                }}
                                inputProps={{
                                  required: true,
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === Keys.ENTER) {
                                    e.preventDefault();
                                    handleMUISelectEvent(e);
                                  }
                                }}
                                disabled={
                                  operation === Operation.VIEW ? true : false
                                }
                              />
                            </div>
                          );
                        } else {
                          return (
                            <React.Fragment key={key}>
                              <InputHoc
                                LabelName={field.labelName}
                                values={
                                  formData[field.inputName] === DEFAULT_TIME
                                    ? ""
                                    : formData[field.inputName]
                                }
                                name={field.inputName}
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                  handleValueChange(e, meta);
                                }}
                                required={field.required}
                                autoFocus={field.autoFocus}
                                type={field.dataType}
                                disabled={
                                  operation === Operation.VIEW ? true : false
                                }
                              />
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        }
                      }
                    )}
                  </div>
                  <div className=" col">
                    <div className="projects-add__form--details--h">
                      <h4>Other Details</h4>
                    </div>
                    {ProjectDetails.right.map(
                      (field: LabelProps, key: React.Key) => {
                        if (field.dataType === "number") {
                          return (
                            <React.Fragment>
                              <div className="label-grid">
                                <Label>{field.labelName}</Label>
                                <InputNumber
                                  value={formData[field.inputName]}
                                  name={field.inputName}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLInputElement>
                                  ) => handleValueChange(e, meta)}
                                  required={field.required}
                                  maxLength={field.maxLength}
                                  disabled={
                                    operation === Operation.VIEW ? true : false
                                  }
                                />
                              </div>

                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        } else if (field.dataType === "textarea") {
                          return (
                            <React.Fragment key={key}>
                              <div className="label-grid">
                                <Label>{field.labelName}</Label>
                                <TextArea
                                  value={formData[field.inputName]}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLTextAreaElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  type={field.dataType}
                                  rows={3}
                                  name={field.inputName}
                                  disabled={
                                    operation === Operation.VIEW ? true : false
                                  }
                                />
                              </div>

                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        } else if (field.inputName === "agreementFile") {
                          return (
                            <div className="label-grid">
                              <Label>{field.labelName}</Label>

                              <div className="items__add--form--flex">
                                <Input
                                  value={
                                    formData.agreementFile
                                      ? formData.agreementFile.split("/")[2]
                                      : ""
                                  }
                                  disabled
                                />
                                {operation !== Operation.VIEW ? (
                                  <label className="items__add--form--details--browse">
                                    <img
                                      src={
                                        formData.agreementFile === ""
                                          ? FileAttach
                                          : Upload
                                      }
                                      alt="/"
                                      className="browse-icon"
                                    />
                                    {formData.agreementFile === ""
                                      ? "Browse"
                                      : "Upload"}
                                    <input
                                      id="student-documents__browse--inputTag"
                                      type="file"
                                      className="assignment-creation__fileattach--input"
                                      onChange={(
                                        e: React.ChangeEvent<HTMLInputElement>
                                      ) => {
                                        if (e.target.files) {
                                          setFormData({
                                            ...formData,
                                            agreementFile: `${customer_id}/ticketDetails/${
                                              e.target.files[0].name.split("/")[
                                                e.target.files[0].name.split(
                                                  "/"
                                                ).length - 1
                                              ]
                                            }`,
                                          });

                                          setAgreementFile(e.target.files[0]);
                                        }
                                      }}
                                      accept="jpg, .png, .jpeg"
                                    />
                                  </label>
                                ) : (
                                  field.inputName === "agreementFile" &&
                                  formData.agreementFile && (
                                    <img
                                      src={Eye}
                                      alt="Eye"
                                      onClick={() => {
                                        let image = `${customer_id}/vendor/${
                                          empDetails.supplierId
                                        }/projects/${
                                          state.projectId
                                        }/agreementFile.${
                                          formData.agreementFile.split(".")[
                                            formData.agreementFile.split(".")
                                              .length - 1
                                          ]
                                        }`;
                                        getDownloadUrl(image, true);
                                      }}
                                    />
                                  )
                                )}
                              </div>
                            </div>
                          );
                        } else if (field.inputName === "endAgreementFile") {
                          return (
                            <div className="label-grid">
                              <Label>{field.labelName}</Label>
                              <div className="items__add--form--flex">
                                <Input
                                  value={
                                    formData.endAgreementFile
                                      ? formData.endAgreementFile.split("/")[2]
                                      : ""
                                  }
                                  disabled
                                />
                                {operation !== Operation.VIEW ? (
                                  <label className="items__add--form--details--browse">
                                    <img
                                      src={
                                        formData.endAgreementFile === ""
                                          ? FileAttach
                                          : Upload
                                      }
                                      alt="/"
                                      className="browse-icon"
                                    />
                                    {formData.endAgreementFile === ""
                                      ? "Browse"
                                      : "Upload"}
                                    <input
                                      id="student-documents__browse--inputTag"
                                      type="file"
                                      className="assignment-creation__fileattach--input"
                                      onChange={(
                                        e: React.ChangeEvent<HTMLInputElement>
                                      ) => {
                                        if (e.target.files) {
                                          setFormData({
                                            ...formData,
                                            endAgreementFile: `${customer_id}/ticketDetails/${
                                              e.target.files[0].name.split("/")[
                                                e.target.files[0].name.split(
                                                  "/"
                                                ).length - 1
                                              ]
                                            }`,
                                          });
                                          setEndAgreementFile(
                                            e.target.files[0]
                                          );
                                        }
                                      }}
                                      accept="jpg, .png, .jpeg"
                                    />
                                  </label>
                                ) : (
                                  field.inputName === "endAgreementFile" &&
                                  formData.endAgreementFile && (
                                    <img
                                      src={Eye}
                                      alt="Eye"
                                      onClick={() => {
                                        let image = `${customer_id}/vendor/${
                                          empDetails.supplierId
                                        }/projects/${
                                          state.projectId
                                        }/endAgreementFile.${
                                          formData.endAgreementFile.split(".")[
                                            formData.endAgreementFile.split(".")
                                              .length - 1
                                          ]
                                        }`;
                                        getDownloadUrl(image, true);
                                      }}
                                    />
                                  )
                                )}
                              </div>
                            </div>
                          );
                        } else {
                          return (
                            <React.Fragment key={key}>
                              <InputHoc
                                LabelName={field.labelName}
                                values={
                                  formData[field.inputName] === DEFAULT_TIME
                                    ? ""
                                    : formData[field.inputName]
                                }
                                name={field.inputName}
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                  handleValueChange(e, meta);
                                }}
                                required={field.required}
                                autoFocus={field.autoFocus}
                                type={field.dataType}
                                disabled={
                                  operation === Operation.VIEW ? true : false
                                }
                              />
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        }
                      }
                    )}
                  </div>
                </div>
                {operation !== Operation.VIEW ? (
                  <>
                    <Button mode={"save"} type="submit" />
                    <Button mode="clear" type="button" onClick={handleClear} />
                  </>
                ) : (
                  ""
                )}
                {(state.empSubType === empType.SYS_ADMIN ||
                  state.empSubType === empType.PMU) && (
                  <Button
                    mode="addnew"
                    type="button"
                    onClick={() => {
                      setProjectExtModalFlag(true);
                    }}
                  >
                    
                    {` Extension`}
                  </Button>
                )}
                <Button
                  mode="view"
                  type="button"
                  onClick={() => {
                    setProjectExtViewModalFlag(true);
                  }}
                > {` Extension`}</Button>

                <Button
                  mode={"cancel"}
                  type="button"
                  onClick={() => {
                    setModalFlag(false);
                  }}
                />
                 
              </Form>
            );
          }}
        </Formik>
      </div>

      <Modal isOpen={supplierModal} ariaHideApp={false} style={AddModalStyles}>
        <Supplier
          pageType={PageFor.MODAL}
          setModalFlag={setSupplierModal}
          project={true}
        />
      </Modal>

      <Modal
        isOpen={projectExtModalFlag}
        style={AddModalStyles}
        ariaHideApp={false}
      >
        <AddProjectExtDetails
          setModalFlag={setProjectExtModalFlag}
          operation={Operation.CREATE}
        />
      </Modal>
      <Modal
        isOpen={projectExtViewModalFlag}
        style={AddModalStyles}
        ariaHideApp={false}
      >
        <ProjectExtDetails
          setModalFlag={setProjectExtViewModalFlag}
          pageType={PageFor.MODAL}
        />
      </Modal>
      <MessageModal
        handleClose={handleClose}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
      <LoadingModal flag={AddProjectLoading || updateLoading || loading} />
    </>
  );
};

export default AddProjectDetails;
